import linkParser from './link';
import paragraphParser from './paragraph';
import wistiaParser from './wistia';

const parser = {
  link: linkParser,
  paragraph: paragraphParser,
  wistia: wistiaParser,
};

export default parser;
